import React, { useState } from 'react';
import { Lightbulb, MessageCircle, Copy, Check, X } from 'lucide-react';
import './Ideas.css';

const Ideas: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [copiedUsername, setCopiedUsername] = useState('');

  const handleContactClick = () => {
    const discordUsername = Math.random() < 0.5 ? 'snowylol_' : 'spookythenobody';
    navigator.clipboard.writeText(discordUsername);
    setCopiedUsername(discordUsername);
    setShowPopup(true);
    
    // Auto-hide popup after 3 seconds
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  };

  return (
    <section id="ideas" className="ideas">
      <div className="container">
        <div className="ideas-banner">
          <div className="banner-content">
            <div className="banner-icon">
              <Lightbulb size={32} />
            </div>
            <div className="banner-text">
              <h3>Have an idea for our town?</h3>
              <p>We'd love to hear your suggestions! Contact us on Discord to share your thoughts.</p>
            </div>
            <div className="banner-actions">
              <button className="contact-btn" onClick={handleContactClick}>
                <MessageCircle size={20} />
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="popup-close" onClick={() => setShowPopup(false)}>
              <X size={20} />
            </button>
            <div className="popup-icon">
              <Check size={32} />
            </div>
            <h3>Username Copied!</h3>
            <p>Discord username <strong>{copiedUsername}</strong> has been copied to your clipboard.</p>
            <div className="popup-username">
              <Copy size={16} />
              {copiedUsername}
            </div>
            <p className="popup-instruction">Open Discord and start a conversation!</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Ideas; 